<script lang="ts">import { Container } from "@infinitro/container";
import VipEarnEveryDay from "./parts/momentum/vip-earn-every-day.svelte";
import VipHero from "./parts/momentum/vip-hero.svelte";
import VipRanksBenefits from "./parts/momentum/vip-ranks-benefits.svelte";
import VipTerms from "./parts/momentum/vip-terms.svelte";
import VipWhyJoin from "./parts/momentum/vip-why-join.svelte";
import Faqs from "./parts/faqs.svelte";
</script>

<Container>
	<div class="about-vip-momentum">
		<VipHero />
		<VipWhyJoin />
		<VipEarnEveryDay />
		<VipRanksBenefits />
		<Faqs />
		<VipTerms />
	</div>
</Container>

<style>
	.about-vip-momentum {
		margin-left: auto;
		margin-right: auto;
		display: flex;
		width: 100%;
		max-width: 1232px;
		flex-direction: column;
		gap: 2rem;
		padding-left: 1rem;
		padding-right: 1rem
}
	@media (min-width: 1024px) {
		.about-vip-momentum {
				gap: 4rem
		}
	}
</style>
